module.exports = __webpack_public_path__ + "media/images/emoticons/postoffice-ce9c316b2609a8b860710a8a0a00a670.gif";